import { Theme } from "common";

export const studyTableStyles = {
  headerCheckbox: {
    color: "#FFFFFF",
  },
  tableScroll: {
    margin: "16px 0px",
    "& .MuiTableContainer-root": {
      overflowX: "auto",
    },
    "& .MuiTableSortLabel-icon": {
      alignSelf: "center",
    },
    "& .MuiTableCell-stickyHeader": {
      zIndex: "0",
    },
  },
  tableCell: {
    "& .MuiTableCell-root": {
      verticalAlign: "top",
      wordBreak: "break-word",
    },
  },
  noteTableCell: {
    maxWidth: "100px",
  },

  noteTableCellHeight: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    lineHeight: 1,
    maxHeight: "75px",
    fontSize: "15px",
  },

  nicknameTableCell: {
    minWidth: "250px",
  },
  protocolNumberTableCell: {
    minWidth: "100px",
  },
  highlightRow: {
    backgroundColor: "#FED8B1",
  },
  studyNote: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  lightTooltip: {
    backgroundColor: Theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: Theme.shadows[1],
    fontSize: "12px",
  },
  lightTooltipArrow: {
    color: Theme.palette.common.white,
  },
  riskContainer: {
    display: "flex",
    riskcount: {
      color: Theme.palette.error.main,
      fontWeight: "bold",
      marginTop: "4px",
    },
    warningIcon: {
      color: Theme.palette.warning.main,
    },
  },
};
